var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { CssClassBuilder } from "survey-core";
import { attachKey2click, ReactElementFactory, SurveyElementBase, SvgIcon, } from "survey-react-ui";
var ActionButton = /** @class */ (function (_super) {
    __extends(ActionButton, _super);
    function ActionButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActionButton.prototype.renderElement = function () {
        var classes = new CssClassBuilder()
            .append(this.props.classes)
            .append("svc-action-button")
            .append("svc-action-button--selected", !!this.props.selected)
            .append("svc-action-button--disabled", !!this.props.disabled)
            .toString();
        if (this.props.iconName) {
            return this.renderIcon(classes);
        }
        return this.renderButtonText(classes);
    };
    ActionButton.prototype.renderButtonText = function (classes) {
        var _this = this;
        if (this.props.disabled) {
            return React.createElement("span", { className: classes }, this.props.text);
        }
        return (React.createElement(React.Fragment, null, attachKey2click(React.createElement("span", { role: "button", className: classes, onClick: function (e) {
                if (!_this.props.allowBubble) {
                    e.stopPropagation();
                }
                _this.props.click();
            }, title: this.props.title }, this.props.text))));
    };
    ActionButton.prototype.renderIcon = function (classes) {
        var _this = this;
        classes += " svc-action-button--icon";
        if (this.props.disabled) {
            return React.createElement("span", { className: classes },
                React.createElement(SvgIcon, { size: "auto", iconName: this.props.iconName }));
        }
        return (React.createElement(React.Fragment, null, attachKey2click(React.createElement("span", { className: classes, onClick: function (e) {
                if (!_this.props.allowBubble) {
                    e.stopPropagation();
                }
                _this.props.click();
            }, title: this.props.title },
            React.createElement(SvgIcon, { size: "auto", iconName: this.props.iconName })))));
    };
    return ActionButton;
}(SurveyElementBase));
export { ActionButton };
ReactElementFactory.Instance.registerElement("svc-action-button", function (props) { return React.createElement(ActionButton, props); });
